module.exports = __webpack_public_path__ + "assets/img/driver-btn-609c6b78.png";